import { t } from 'i18next';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { useAddContactGroupByEmailContext } from 'contacts/components/AddContactGroupByEmail';
import { Confirmation } from 'core/components';
import { FormProvider } from 'core/states';
import { Color } from 'theme/enums';

import { ContactEmailFormFields } from './ContactEmailFormFields';

const schema = () =>
  yup.object({
    email: yup.string().email().label(t('labelContactEmail')).nullable().required(),
  });

export const ContactEmail = () => {
  const { t } = useTranslation();

  const {
    contactEmail,
    contactEmailRef,
    contactDeletedWarning,
    onContactEmailDeletedConfirm,
    onContactEmailDeletedCancel,
  } = useAddContactGroupByEmailContext();

  const defaultValues = useMemo(() => ({ email: contactEmail }), [contactEmail]);

  return (
    <FormProvider schema={schema()} defaultValues={defaultValues}>
      <ContactEmailFormFields ref={contactEmailRef} />

      <Confirmation
        isOpen={contactDeletedWarning}
        color={Color.DANGER}
        title={t('titleWarning')}
        message={t('messageConfirmRestoreDeletedContact', {
          contactEmail,
        })}
        onCancel={onContactEmailDeletedCancel}
        onConfirm={onContactEmailDeletedConfirm}
        confirmBtnColor={Color.DANGER}
      />
    </FormProvider>
  );
};
